const state = {
  uploadImage: [],
  sendPhotoLater: true,
  takePhotoWithGuidedCamera: false,
  openedGuidedCamera: false,
}

const getters = {
  uploadImage (state) {
    return state.uploadImage
  },
  sendPhotoLater (state) {
    return state.sendPhotoLater
  },
  takePhotoWithGuidedCamera (state) {
    return state.takePhotoWithGuidedCamera
  },
  openedGuidedCamera (state) {
    return state.openedGuidedCamera
  },
}
const actions = {
  setUploadedImages (context, data) {
    context.commit('setUploadedImages', data)
  },
  clearImages (context) {
    context.commit('clearImages')
  },
  async clearImagesWithPersistence () {
    // Import UploadPersistenceService dynamically to avoid circular dependency
    localStorage.removeItem('photoUploadState')
    const { default: UploadPersistenceService } = await import('@/helper/upload-persistence')
    await UploadPersistenceService.clearAllFileData()
  },
  setSendPhotoLater (context, data) {
    context.commit('setSendPhotoLater', data)
  },
  clearSendPhotoLater (context) {
    context.commit('clearSendPhotoLater')
  },
  setTakePhotoWithGuidedCamera (context, data) {
    context.commit('setTakePhotoWithGuidedCamera', data)
  },
  setOpenedGuidedCamera (context, data) {
    context.commit('setOpenedGuidedCamera', data);
  },
}

const mutations = {
  setUploadedImages (state, payload) {
    state.uploadImage = payload
  },
  clearImages (state) {
    state.uploadImage = []
  },
  setSendPhotoLater (state, payload) {
    state.sendPhotoLater = payload
  },
  clearSendPhotoLater (state) {
    state.sendPhotoLater = true
  },
  setTakePhotoWithGuidedCamera (state, payload) {
    state.takePhotoWithGuidedCamera = payload
  },
  setOpenedGuidedCamera (state, data) {
    state.openedGuidedCamera = data
  },
}
export default {
  state,
  getters,
  actions,
  mutations
}